import ArrowIcon from 'icons/arrow.svg';
import { useRouter } from 'next/router';
import { cls } from 'reactutils';

export function SimpleNavbar({
  children,
  showBack = true,
  rightComp,
  title = '',
  borderBottom,
  fixed = false,
  onBack,
  style,
}: {
  children?: React.ReactNode;
  showBack?: boolean;
  rightComp?: React.ReactNode;
  title?: string;
  borderBottom?: boolean;
  fixed?: boolean;
  onBack?: Function;
  style?: any;
}) {
  const router = useRouter();
  const handleOnBack = onBack ? onBack : () => router.back();

  return (
    <>
      <div
        className={cls('simple-navbar', 'box', borderBottom && 'border', fixed && 'fixed')}
        style={style}
      >
        <div className="main">
          {showBack && <ArrowIcon className="back" onClick={handleOnBack} />}
          {children || <div className="title">{title}</div>}
          {rightComp && <div className="rightComp">{rightComp}</div>}
        </div>
      </div>
      <style jsx>{`
        .box {
          width: 100%;
          position: relative;
          background-color: #fff;
        }

        .box.fixed {
          position: fixed;
          left: 0;
          right: 0;
          top: 0;
        }

        .box.border {
          border-bottom: 1px solid #f1f1f1;
        }

        .box :global(.back) {
          position: absolute;
          left: 10px;
          bottom: 14px;
          transform: rotate(180deg);
          width: 16px;
          height: 16px;
        }
        .main {
          height: 44px;
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
        }

        .title {
          font-size: 17px;
          color: #262626;
          font-weight: bolder;
        }

        .rightComp {
          position: absolute;
          bottom: 0;
          top: 0;
          right: 16px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      `}</style>
    </>
  );
}
